module.exports = __webpack_public_path__ + "img/file.f9f15026.svg";